import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'

import Shared from 'Services/Shared'

import {
  createAuthLink,
  createErrorLink,
  createRequestLink,
  createRetryLink,
} from './Links'

function createApolloClient() {
  const cache = new InMemoryCache()

  const client = new ApolloClient({
    link: ApolloLink.from([
      createErrorLink(),
      createRetryLink(),
      createAuthLink(),
      createRequestLink(),
    ]),
    cache,
    connectToDevTools: process.env.NODE_ENV === 'development',
    ssrMode: typeof window === 'undefined',
  })

  Shared.setApolloClient(client)

  return client
}

export { createApolloClient }
